import React from "react";
import { t } from "ttag";

import { CRMForm, FormType, WhoAreYouSelect } from "../CRMForm";
import { ButtonPrimary } from "../Clickables";
import { TextField } from "../Forms/Input";
import { FormLayout } from "./CRMForm";

import styles from "./forms.module.scss";

export const LocalContactForm = (props: FormLayout) => {
    return (
        <CRMForm
            layout={props.layout}
            type={FormType.LOCAL_REP_CONTACT}
            custom_submit_url={props.custom_submit_url}
        >
            {(disabled, legal) => (
                <>
                    <TextField
                        label={t`Email Address`}
                        className={styles.input}
                        name="email_address"
                        isRequired
                        type="email"
                    />
                    <WhoAreYouSelect className={styles.input} />
                    <TextField
                        label={t`First Name`}
                        className={styles.input}
                        name="first_name"
                        isRequired
                    />
                    <TextField
                        label={t`Last Name`}
                        className={styles.input}
                        name="last_name"
                        isRequired
                    />
                    <TextField
                        label={t`ZIP Code`}
                        className={styles.input}
                        name="zip_code"
                        isRequired
                    />
                    <TextField
                        label={t`If you are working with a dealer, please specify the dealer name`}
                        className={styles.input}
                        name="dealer_name"
                    />
                    <TextField
                        label={t`Anything else you would like us to know about your project?`}
                        className={styles.input}
                        name="message"
                        textArea={true}
                    />
                    {legal}
                    <div className={styles.submitContainer}>
                        <ButtonPrimary type="submit" disabled={disabled}>
                            {t`Submit`}
                        </ButtonPrimary>
                    </div>
                </>
            )}
        </CRMForm>
    );
};
